<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
      <img v-if="sidebarOpened" style="width: 148.5px;height: 26px;" src="@/assets/images/logo.png" alt="logo" />
      <img v-else style="width: 32px;height: 32px;" src="@/assets/images/mobile_logo.png" alt="logo" />
      <h1 v-if="showTitle">{{ projectName }}</h1>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    ...mapState(['sidebarOpened'])
  }
}
</script>
